import {
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { SalesService } from 'src/app/services/api/sales.service';
import { NotificationService } from 'src/shared/notification.service';

@Component({
  selector: 'app-edit-total-pax',
  templateUrl: './edit-total-pax.component.html',
  styleUrls: ['./edit-total-pax.component.scss'],
})
export class EditTotalPaxComponent implements OnInit, OnDestroy {
  unsubscribeOnDestroy$: Subject<boolean> = new Subject<boolean>();

  loading: boolean = false;
  success: boolean = false;
  form: FormGroup;
  @Output() changeValueProps: EventEmitter<any> = new EventEmitter<any>();
  columnName: string = '';
  titleColumn: string = '';
  constructor(
    public dialogRef: MatDialogRef<EditTotalPaxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private readonly fb: FormBuilder,
    private readonly salesService: SalesService,
    private readonly notificationService: NotificationService,
  ) {
    this.form = this.fb.group({
      total: new FormControl(data?.value || null, Validators.required),
    });
    this.columnName = this.data.columnName;

    this.titleColumn = 'Asistente Picnic + Bañero + Cocinero + Personal Campo';
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.unsubscribeOnDestroy$.next(true);
    this.unsubscribeOnDestroy$.complete();
    this.OnClose();
  }

  close() {
    this.dialogRef.close();
  }

  applyFilterSelect() {}

  async save() {
    this.loading = true;
    const total = this.form.value.total;
    this.salesService
      .updateServiceItinerary({
        id: this.data.data.id,
        [this.columnName]: total,
      })
      .subscribe(
        (data) => {
          this.success = true;
          this.loading = false;
          this.notificationService.showSuccessAlert(
            'Se actualizó el servicio exitosamente.',
          );
          this.OnClose();
        },
        (err: any) => {
          this.loading = false;
          this.notificationService.notifyError(err.message);
        },
      );
  }
  onNumberInput(event: any) {
    const input = event.target.value;
    const numericValue = input.replace(/\D/g, '');
    if (input !== numericValue) {
      this.form.get(event.target.name)?.setValue(numericValue);
    }
  }

  OnClose() {
    this.dialogRef.close({
      success: this.success,
      total: this.form.value.total,
    });
  }
  onCancel() {
    this.OnClose();
  }
}
